import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router-dom";
import iconMap from "../untils/iconmap";

export default function Footer({ content, sociallinks }) {

    const [isVisible, setIsVisible] = useState(false);
    const componentRef = useRef(null);

    const [activeIndex, setActiveIndex] = useState(0);
    const [forward, setForward] = useState(true);

    // ✅ Footer fade animation on scroll
    useEffect(() => {
        const handleScroll = () => {
            if (componentRef.current) {
                const top = componentRef.current.getBoundingClientRect().top;
                const windowHeight = window.innerHeight;
                if (top < windowHeight) setIsVisible(true);
            }
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll();
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // ✅ Social icon auto animation
    useEffect(() => {
        const interval = setInterval(() => {
            setActiveIndex(prev => {
                if (forward) {
                    if (prev === sociallinks.length - 1) {
                        setForward(false);
                        return prev - 1;
                    }
                    return prev + 1;
                } else {
                    if (prev === 0) {
                        setForward(true);
                        return prev + 1;
                    }
                    return prev - 1;
                }
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [forward, sociallinks.length]);

    return (
        <>
            <div
                ref={componentRef}
                className={`w-full transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}
            >
                <footer className="bg-black/20 text-white py-10 px-5">

                    {/* ✅ Top Section */}
                    <div className="container mx-auto md:px-6 px-1 flex flex-col md:flex-row justify-between md:items-center gap-y-2">

                        {/* Logo + Privacy */}
                        <div className="flex items-center flex-wrap gap-x-5">
                            <div className="flex items-center space-x-2">
                                <img src={content.logo} alt="logo" className="h-8" />
                                <h2>{content.company_name}</h2>
                            </div>
                            <div>
                                | <Link to={content.privacy_link.link}>
                                    <span className="text-blue-500 underline">{content.privacy_link.text}</span>
                                </Link> |  {content.text}
                            </div>
                        </div>

                        {/* Contact Email */}
                        <div className="flex items-center gap-x-2">
                            <p className="text-sm">Connect with us:</p>
                            <a href={`mailto:${content.company_email}`} className="flex items-center space-x-2 text-blue-400 hover:text-blue-300">
                                <FontAwesomeIcon icon={faEnvelope} className="h-5 w-5" />
                                <span className="underline">{content.company_email}</span>
                            </a>
                        </div>

                    </div>
                </footer>
            </div>
            <div className="fixed top-1/2 left-0 -translate-y-1/2 z-50">
                <div className="flex flex-col gap-4">
                    {sociallinks.map((item, index) => (
                        <div
                            key={index}
                            className={`flex items-center justify-center  text-yellow-500 cursor-pointer 
                                transition-all duration-500
                                ${activeIndex === index ? "translate-x-3" : "translate-x-0"}
                            `}
                        >
                            <FontAwesomeIcon
                                icon={iconMap[item.name]}
                                className="text-lg"
                            />
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}
